export const user_is_last_company_admin = 'user_is_last_company_admin';
